// @ts-nocheck
import { FC, useEffect, useState } from 'react';
import { FormikProps, FormikValues } from 'formik';
import styled from 'styled-components';
import { GoogleApiWrapper, IMapProps, Map, Marker } from 'google-maps-react';
import { GOOGLE_API } from '../../consts';

interface MapProps {
  formikProps: FormikProps<FormikValues>;
  google: any;
  lat: string | number | null;
  lng: string | number | null;
  alt?: string | number | null;
}

const MapWrapper = styled.div`
  min-height: 380px;
  width: calc(46vw / var(--ib-ui-scale, 1));

  & div {
    max-width: calc(45vw / var(--ib-ui-scale, 1));
    max-height: 380px;
  }
`;

const MapContainer: FC<MapProps> = props => {
  const [latitude, setLatitude] = useState(props.lat);
  const [longitude, setLongitude] = useState(props.lng);
  const [altitude, setAltitude] = useState(props.alt);

  useEffect(() => {
    props.formikProps.setFieldValue('gisLatitude', String(latitude));
  }, [latitude, props.formikProps]);

  useEffect(() => {
    props.formikProps.setFieldValue('gisLongitude', String(longitude));
  }, [longitude, props.formikProps]);

  useEffect(() => {
    if (props.alt !== undefined) {
      props.formikProps.setFieldValue('gisAltitude', String(altitude));
    }
  }, [altitude, props.formikProps, props.alt]);

  const onMapClicked = (mapProps?: IMapProps, map?: any, coord?: any) => {
    setLatitude(coord.latLng.lat());
    setLongitude(coord.latLng.lng());
    if (!!mapProps && props.alt !== undefined) {
      const google = mapProps.google;
      const elevationService = new google.maps.ElevationService();
      elevationService
        .getElevationForLocations({
          locations: [coord.latLng],
        })
        .then((results: any) => {
          // console.log(results);
          const elevation =
            results.results.length === 0 ? '' : String(Math.round(results.results[0].elevation * 10000.0) / 10000.0);
          setAltitude(elevation);
        })
        .catch((error: any) => {
          console.error(error);
        });
    }
  };

  return (
    <MapWrapper>
      <Map
        google={props.google}
        initialCenter={{ lat: latitude, lng: longitude }}
        center={{ lat: latitude, lng: longitude }}
        onDblclick={onMapClicked}
      >
        <InitAltitude
          lat={latitude ? latitude.toString() : null}
          lng={longitude ? longitude.toString() : null}
          alt={altitude}
          setAlt={value => setAltitude(value)}
        />
        {/* @ts-ignore */}
        <Marker position={{ lat: latitude, lng: longitude }} />
      </Map>
    </MapWrapper>
  );
};

type InitAltitudeProps = {
  lat: string | null;
  lng: string | null;
  alt: string | number | null | undefined;
  setAlt: (value: string) => void;
};

const InitAltitude: FC<InitAltitudeProps> = props => {
  const { lat, lng, alt, setAlt } = props;
  //console.log("InitAltitude", { lat, lng, alt });

  useEffect(() => {
    if (alt !== undefined && (alt === '' || alt === null) && lat !== '' && lat !== null && lng !== '' && lng != null) {
      //console.log("InitAltitude", "Requesting elevation");
      const google = (props as any).google;
      const elevationService = new google.maps.ElevationService();
      elevationService
        .getElevationForLocations({
          locations: [{ lat: parseFloat(lat), lng: parseFloat(lng) }],
        })
        .then((results: any) => {
          // console.log(results);
          const elevation =
            results.results.length === 0 ? '' : String(Math.round(results.results[0].elevation * 10000.0) / 10000.0);
          setAlt(elevation);
        })
        .catch((error: any) => {
          console.error(error);
        });
    }
  }, []);

  return null;
};

export default GoogleApiWrapper({
  apiKey: GOOGLE_API,
})(MapContainer);
